export type { ActionDotPhrase } from './dotPhrases';
export { withDotPhraseHint } from './dotPhrases';
